/**
 * Teilaufgaben, Checklisten, Verknuepfungen und Wiedervorlagen.
 */

import type { components } from '../../../api/schema';
import { request } from '../../../lib/apiClient';

export type Task = components['schemas']['TaskRead'];
export type TaskCreate = components['schemas']['TaskCreate'];
export type TaskUpdate = components['schemas']['TaskUpdate'];
export type TaskStatus = components['schemas']['TicketTaskStatus'];

export type Checklist = components['schemas']['ChecklistRead'];
export type ChecklistCreate = components['schemas']['ChecklistCreate'];
export type ChecklistItem = components['schemas']['ChecklistItemRead'];

export type TicketLink = components['schemas']['LinkRead'];
export type LinkCreate = components['schemas']['LinkCreate'];
export type LinkType = components['schemas']['LinkType'];

export type Reminder = components['schemas']['ReminderRead'];
export type ReminderSet = components['schemas']['ReminderSet'];

export function listTasks(ticketId: string): Promise<Task[]> {
  return request<Task[]>(`/tickets/${ticketId}/tasks`);
}

export function createTask(ticketId: string, payload: TaskCreate): Promise<Task> {
  return request<Task>(`/tickets/${ticketId}/tasks`, { method: 'POST', body: payload });
}

export function updateTask(ticketId: string, taskId: string, payload: TaskUpdate): Promise<Task> {
  return request<Task>(`/tickets/${ticketId}/tasks/${taskId}`, { method: 'PATCH', body: payload });
}

export function deleteTask(ticketId: string, taskId: string): Promise<undefined> {
  return request<undefined>(`/tickets/${ticketId}/tasks/${taskId}`, { method: 'DELETE' });
}

export function listChecklists(ticketId: string): Promise<Checklist[]> {
  return request<Checklist[]>(`/tickets/${ticketId}/checklists`);
}

export function addChecklist(ticketId: string, payload: ChecklistCreate): Promise<Checklist> {
  return request<Checklist>(`/tickets/${ticketId}/checklists`, { method: 'POST', body: payload });
}

export function toggleChecklistItem(
  ticketId: string,
  itemId: string,
  isDone: boolean,
): Promise<ChecklistItem> {
  return request<ChecklistItem>(`/tickets/${ticketId}/checklist-items/${itemId}`, {
    method: 'POST',
    body: { is_done: isDone },
  });
}

export function listLinks(ticketId: string): Promise<TicketLink[]> {
  return request<TicketLink[]>(`/tickets/${ticketId}/links`);
}

export function createLink(ticketId: string, payload: LinkCreate): Promise<TicketLink> {
  return request<TicketLink>(`/tickets/${ticketId}/links`, { method: 'POST', body: payload });
}

export function deleteLink(ticketId: string, linkId: string): Promise<undefined> {
  return request<undefined>(`/tickets/${ticketId}/links/${linkId}`, { method: 'DELETE' });
}

export function getReminder(ticketId: string): Promise<Reminder | null> {
  return request<Reminder | null>(`/tickets/${ticketId}/reminder`);
}

export function setReminder(ticketId: string, payload: ReminderSet): Promise<Reminder> {
  return request<Reminder>(`/tickets/${ticketId}/reminder`, { method: 'POST', body: payload });
}

export function clearReminder(ticketId: string): Promise<undefined> {
  return request<undefined>(`/tickets/${ticketId}/reminder`, { method: 'DELETE' });
}
